import React, { FC } from 'react'
import errorIcon from '@mortgage-pos/ui/assets/error.svg'

type InfoBlockType = 'info' | 'danger'

interface Props {
  type?: InfoBlockType
  title?: string
  setAsHtmlError?: boolean
  children: React.ReactNode | string
}

const InfoBlock: FC<Props> = ({
  children,
  type = 'info',
  title,
  setAsHtmlError = false,
}) => {
  return (
    <aside data-testid="info-block" className={`info-block --${type}`}>
      {title ? <h3 className="info-block__title">{title}</h3> : null}
      <div className="info-block__content">
        {setAsHtmlError ? (
          <div
            className="info-block__text"
            dangerouslySetInnerHTML={{ __html: children }}
          />
        ) : (
          <div className="info-block__text" data-testid="info-block-text">
            {children?.toString()}
          </div>
        )}
        <div className="info-block__error-button">
          {type === 'danger' ? (
            <img
              className="info-block__error-button-icon"
              src={errorIcon}
              alt="error icon"
            />
          ) : null}
        </div>
      </div>
    </aside>
  )
}

export default InfoBlock
